import getLocal from '@/app/utils/getLocal';
import EcoTextTc, { EcoTextTcItemProps } from 'eco-design/sections/eco-text-tc';
import styles from './index.module.scss';
import { tcLang } from './lang';

export default function Comp() {
    const { locale } = getLocal();
    const tcLanguage = tcLang[locale] || tcLang['us'];

    let items: EcoTextTcItemProps[] = [
        {
            title: tcLanguage.titleA1,
            desc: tcLanguage.descA1,
            isOpen: true,
        },
        {
            title: tcLanguage.titleA2,
            desc: tcLanguage.descA2,
        },
        {
            title: tcLanguage.titleA3,
            desc: tcLanguage.descA3,
        },
        {
            title: tcLanguage.titleA4,
            desc: tcLanguage.descA4,
        },
    ];
    if (locale === 'us') {
        items = [
            {
                isHead: true,
                title: tcLanguage.head1,
            },
            { title: tcLanguage.titleA5, desc: tcLanguage.descA5, isOpen: true },
            ...items.map((i) => ({ ...i, isOpen: false })),
        ];
    } else if (locale === 'ca') {
        items = [
            {
                isHead: true,
                title: tcLanguage.head1,
            },
            ...items.map((i) => ({ ...i })),
        ];
    }
    return (
        <div id="shp3-FooterTcA" className="GtmModuleData-section" data-section-id={'shp3-FooterTcA '} data-section-title={tcLanguage.head1}>
            <EcoTextTc items={items} className={styles.comp} theme="black" />
        </div>
    );
}
